import { uniq } from 'es-toolkit/compat';

export const splitResourceIds = (resourceIds: string): string[] =>
    uniq(
        resourceIds
            .trim()
            .split(/[,; ]+/)
            .filter(item => item)
    );
